module.exports = __webpack_public_path__ + "img/cloth_g2_sleeve_14.27cf1281.svg";